import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { DiagramDisplayCard } from '@/components/layout/DiagramDisplayCard/DiagramDisplayCard';
import { COLORS } from '@/styles/tokens/colors';

export interface ArtifactTemplateCardProps {
  title: string;
  description: string;
  /** Shows centered in the gray band at the top of the card. */
  icon: ReactNode;
  onClick: () => void;
  /** Omit for action cards. Set a boolean for selection cards. */
  selected?: boolean;
  disabled?: boolean;
}

/** A Studio template card for a diagram or memo template. */
export function ArtifactTemplateCard({
  title,
  description,
  icon,
  onClick,
  selected,
  disabled,
}: ArtifactTemplateCardProps) {
  return (
    <DiagramDisplayCard
      ariaLabel={title}
      value={title}
      selected={selected}
      disabled={disabled}
      onClick={onClick}
      // Each wrapped row stretches its cards to one height. A percentage
      // height would size every card to the whole wrapped area.
      sx={{
        width: 224,
        maxWidth: '100%',
        height: 'auto',
        color: COLORS.GRAY[600],
      }}
      bodySx={{ p: 0 }}
    >
      <Box
        aria-hidden
        height={94}
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
        bgcolor={COLORS.GRAY[50]}
      >
        {icon}
      </Box>
      <Box p={1.5}>
        <Typography variant="title-xs">{title}</Typography>
        <Typography variant="body-xs">{description}</Typography>
      </Box>
    </DiagramDisplayCard>
  );
}
